export default "__VITE_ASSET__mCDk2QLg__"